/**
 * "Launch flow" — the three steps plus the launch options table: every
 * optional Create-session field and what the hosted player experience does
 * with it. Partner-facing markdown.
 */
export const launchFlow: string[] = [
  '## Launch flow',
  '',
  '1. Your backend calls **Create session** with the player launch `token`. We call your `get_session`',
  '   webhook to resolve which player that token belongs to, then return a `session_token`.',
  '2. Your front-end uses that `session_token` (header `X-Platform-Session`) to list games, buy packs,',
  '   reveal cards, sell, and read inventory — or simply loads the player iframe with it.',
  '3. Money moves through your wallet via the `debit` / `credit` / `refund` callbacks.',
  '',
  '**Launch options.** Everything besides `token` is optional. This is what the hosted player experience',
  'does with each field:',
  '',
  '| Field | Effect |',
  '| --- | --- |',
  '| `game_id` | Lands the player on that pack instead of the lobby. An id you cannot launch is ignored, never an error. |',
  '| `template` | `classic` or `modern` — the layout. Defaults to your account setting. |',
  '| `context.currency` | The session currency; must be one enabled for your account. Prices and the balance are shown in it. |',
  '| `deposit_url` | Your cashier. When a purchase fails for insufficient balance the player gets an **Add funds** button that opens this URL in a new tab — see *Handling guide → Insufficient balance*. Your page can take it over via `navigate_deposit`. |',
  '| `lobby_url` | Your lobby. Adds a **Back to lobby** button in the header and on the session-expired screen; it navigates the top window there. Your page can take it over via `navigate_lobby`. |',
  '| `platform`, `language`, `context.username`, `context.country` | Stored with the session for your reporting. The UI does not change. |',
  '| `is_test` | Marks the player as a test player, excluded from your reporting (needs the test-player registry). |',
  '| `user` | Pre-authenticated accounts for platforms with registration enabled — see **Create session**. |',
  '',
  'Without `deposit_url` / `lobby_url` the corresponding buttons are simply absent.',
  '',
];
